<template>
  <main class="container alianca-content alianca-content-seuplano">
    <section class="row">
      <div class="main-content main-content-seuplano col-12">
        <loading
          :active.sync="loading"
          :can-cancel="false"
          :is-full-page="true"
          class="overlay-load"
          :z-index="9999"
        ></loading>
        <transition name="fade">
          <div id="seu-plano">
            <div class="header-seu-plano header-assinar-proposta">
              <div class="container header-plano-content">
                <div class="d-flex align-content-center">
                  <p>
                    <img
                      src="../assets/arrow-left.svg"
                      alt="Voltar etapa"
                      @click.prevent="backtofinalizar()"
                    />
                  </p>
                </div>
                <div
                  class="align-flex-title"
                  style="margin-top: -58px; justify-content: end"
                >
                  <h3 style="margin-left: 70px">Finalizar proposta</h3>
                </div>
                <b-row
                  class="resumo-proposta main-header-assinar-proposta"
                  style="height: 88px; margin-top: 28px"
                >
                  <b-col md="8" sm="12" class="subrow-header-assinar-proposta">
                    <b-row>
                      <img
                        src="../assets/protocolo.svg"
                        alt="Protocolo de atendimento"
                        style="margin-left: 37px; margin-right: 21px"
                      />
                      <span style="margin-top: 4px"
                        ><b>Número da sua proposta:</b> {{ numProposta }}</span
                      >
                    </b-row>
                  </b-col>
                  <b-col
                    :md="(!btnPropostaHabilitar) ? '4' : '3'"
                    sm="12"
                    class="border-left-assinatura ml-auto mr-auto"
                  >
                    <b-button
                      :disabled="!btnPropostaHabilitar"
                      @click="assinarProposta()"
                      class="
                        btn-alianca
                        pesquisar-planos pesquisar-planos-inverse
                        btn-assinar-proposta
                      "
                      >
                        <span v-if="!btnPropostaHabilitar">
                          GERANDO LINK DE ASSINATURA
                        </span>
                        <span v-else>
                          ASSINAR PROPOSTA
                        </span>
                      </b-button
                    >
                  </b-col>
                </b-row>
              </div>

              <b-modal id="modal-enviar-documentos">
                <template #modal-header="{ close }">
                  <h5 class="title-modal">
                    Digitalize seus documentos com seu smartphone
                  </h5>
                  <b-button
                    class="close btn-close"
                    aria-label="Close"
                    @click="close()"
                    >×</b-button
                  >
                </template>
                <div class="modal-documentos-content">
                  <p class="modal-documentos-p">
                    Baixe o aplicativo indicado abaixo, ou outro de sua
                    preferência, e digitalize seus documentos pessoais de forma
                    rápida e prática.
                  </p>
                </div>
                <template #modal-footer="{ ok }">
                  <b-button class="btn-enviar-documento" @click="ok()"
                    >ENVIAR DOCUMENTOS</b-button
                  >
                </template>
              </b-modal>
            </div>
          </div>
        </transition>

        <transition name="fade">
          <div id="assinar-proposta">
            <div class="content-assinar-proposta">
              <div class="container">
                <h3>Assine a proposta de adesão e envie os seus documentos</h3>
                <p style="margin-top: 24px">
                  Ao clicar em Assinar você confirma que leu as Condições Gerais
                  da Proposta de Adesão, bem como o Guia de Leitura Contratual e
                  o Manual de Orientação para Contratação de Plano de Saúde.
                </p>
                <br />
                <p>
                  Na sequência, envie os seus documentos digitalizados para
                  finalizar proposta.
                </p>
                <iframe
                  v-if="flagIframe == false"
                  :src="this.url"
                  width="100%"
                  height="1000px"
                ></iframe>
                <iframe
                  class="full-frame"
                  v-else
                  :src="this.urlDocuSignAssinatura"
                  width="100%"
                  height="1000px"
                ></iframe>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </section>
  </main>
</template>

<script>
import store from "../store";
import criptografar from "@/services/criptografar";
import lerDocumentosPorProposta from "@/services/lerDocumentosPorProposta";
import requisicaoAssinatura from "@/services/requisicaoAssinatura";
import atualizarEnvelopeDocuSign from "@/services/atualizarEnvelopeDocuSign"
import Loading from "vue-loading-overlay";
import pegaEnvelopeUrl from "@/services/pegaUrlEnvelope";
import enviarEmail from "@/services/enviarEmail";
export default {
  name: "Assinar-proposta",
  components: {
    Loading,
  },
  data() {
    return {
      btnPropostaHabilitar: false,
      protocolo: 5215689968,
      url: "",
      documentos: [],
      oSignerAttachmentList: [],
      urlDocuSignAssinatura: "",
      flagIframe: false,
      loading: true,
    };
  },
  methods: {
    formatMoney(amount, decimalCount = 2, decimal = ",", thousands = ".") {
      try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? "-" : "";

        let i = parseInt(
          (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
        ).toString();
        let j = i.length > 3 ? i.length % 3 : 0;

        return (
          negativeSign +
          (j ? i.substr(0, j) + thousands : "") +
          i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
          (decimalCount
            ? decimal +
              Math.abs(amount - i)
                .toFixed(decimalCount)
                .slice(2)
            : "")
        );
      } catch (e) {
        console.log(e);
      }
    },
    gotoenviardocumentos() {
      this.$router.push("enviar-documentos");
    },
    backtofinalizar() {
      document
        .getElementById("step-progress-point4")
        .classList.remove("rounded-point-progress-ok");
      document
        .getElementById("globaletapa4")
        .classList.add("etapas-progresso-texto-disabled");
      this.$router.push("finalizar-proposta");
    },
    async imprimirProposta() {
      const chave = await criptografar({
        valor: store.getters.getAliancaProposta.num_proposta,
        chaveCriptografia: "#!$a36?@",
      });
      return chave;
    },
    async lerDocumentosPorProposta(propostaId) {
      const documentos = await lerDocumentosPorProposta(propostaId);
      return documentos;
    },
    async requisicaoAssinatura() {
      try {

        const response = await requisicaoAssinatura({
          urlPDF: this.url,
          nuProposta: store.getters.getAliancaProposta.num_proposta,
          oSignerAttachmentList: this.oSignerAttachmentList,
          localTitular: store.getters.getAliancaEndCidade,
          recipientName: store.getters.getAliancaNome,
          recipientEmail: store.getters.getAliancaEmail,
          recipientNameRF: "",
          recipientEmailRF: "",
        });

        const envelopeId = response.envelopeId;
        const num_proposta = await criptografar({
            valor: store.getters.getAliancaProposta.num_proposta,
            chaveCriptografia: "#!$a36?@",
          });
        const gaWebUrl = `${process.env.VUE_APP_GAWEB_URL}?num_proposta=${num_proposta}&OR=Ar6EOKeseVk=`;
        const urlDocuSign = await pegaEnvelopeUrl({
          envelopeId: envelopeId,
          clientUserId: "1",
          destinatarioName: store.getters.getAliancaNome,
          destinatarioEmail: store.getters.getAliancaEmail,
          num_proposta,
          origem: "SITE",
        });

        // Gera URL do envelope

        await atualizarEnvelopeDocuSign({
          num_proposta: store.getters.getAliancaProposta.num_proposta,
          envelopeId: response.envelopeId,
          dataCriacao: response.statusDateTime.split("T")[0].replace("-","").replace("-",""),
          assinaturaDigital: '',
          statusEnvelope: 1,
          dataAssinaturaRf: '',
          dataAssinaturaTitular: '',
          urlEnvelope: gaWebUrl,
          novoStatusProposta: "150"
        })
        
        const proposta = store.getters.getAliancaProposta;
        
        this.btnPropostaHabilitar = !this.btnPropostaHabilitar;

        // Envia email de Finalização de Proposta
        await enviarEmail({
          email: store.getters.getAliancaEmail,
          gancho: "email_adesao",
          subject: "Bem-vindo à Aliança Administradora",
          data: {
            nome: store.getters.getSimuleAquiNome,
            num_proposta: proposta.num_proposta
          },
        });
        // Envia email de Assinatura de Proposta
        await enviarEmail({
          email: store.getters.getAliancaEmail,
          gancho: "email_envio_proposta",
          subject: "Proposta de Adesão Aliança",
          data: {
            nome: store.getters.getSimuleAquiNome,
            num_proposta: proposta.num_proposta,
            url: gaWebUrl,
          },
        });
        this.urlDocuSignAssinatura = urlDocuSign.url;
      } catch(e) {
        console.log(e);
      }
    },
    assinarProposta() {
      this.flagIframe = true;
    },
  },
  computed: {
    numProposta() {
      const proposta = store.getters.getAliancaProposta;

      return proposta != null ? proposta.num_proposta : "ERROR";
    },
  },
  async mounted() {

    const criptografia = await criptografar({
      valor: store.getters.getAliancaProposta.num_proposta,
      chaveCriptografia: "#!$a36?@",
    })

    const documentos = await lerDocumentosPorProposta(store.getters.getAliancaProposta.num_proposta);

    this.documentos = documentos;

    for (const documento of this.documentos) {
      this.oSignerAttachmentList.push({
        TabLabel: "Anexar Documento - " + documento.descricao,
        DocumentId: "1",
        Name:
          "DOCUSIGN_DOC_" +
          documento.cod_doc +
          "_" +
          documento.cod_contato +
          (documento.docObrig == "1" ? "_OB" : "_OP"),
        TabId:
          "DOCUSIGN_DOC_" +
          documento.cod_doc +
          "_" +
          documento.cod_contato +
          (documento.docObrig == "1" ? "_OB" : "_OP"),
        Optional: documento.docObrig == "0" ? "true" : "false",
        AnchorXOffset: "50",
        AnchorYOffset: "-40",
        AnchorString:
          "DOCUSIGN_DOC_" +
          documento.cod_doc +
          "_" +
          documento.cod_contato +
          (documento.docObrig == "1" ? "_OB" : "_OP"),
      });
    }

    this.url = `${process.env.VUE_APP_IMPRIMIR_PROPOSTA}?proposta=${criptografia}&leg=1&AssDigital=1`;

    this.requisicaoAssinatura();

    this.loading = false;

    // console.log(this.imprimirProposta().PromiseResult)
    document.getElementById("step-progress").value = 100;
    document
      .getElementById("step-progress-point1")
      .classList.add("rounded-point-progress-ok");
    document
      .getElementById("step-progress-point2")
      .classList.add("rounded-point-progress-ok");
    document
      .getElementById("step-progress-point3")
      .classList.add("rounded-point-progress-ok");
    document
      .getElementById("step-progress-point4")
      .classList.add("rounded-point-progress-ok");
    document
      .getElementById("globaletapa2")
      .classList.remove("etapas-progresso-texto-disabled");
    document
      .getElementById("globaletapa3")
      .classList.remove("etapas-progresso-texto-disabled");
    document
      .getElementById("globaletapa4")
      .classList.remove("etapas-progresso-texto-disabled");

    for (let i = 1; i <= 4; i++) {
      document
        .getElementById("globaletapam" + i)
        .classList.remove("etapas-progresso-mobile-show");
      document
        .getElementById("globaletapaprox" + i)
        .classList.remove("div-proximo-etapa-mobile-show");
    }

    document
      .getElementById("globaletapam4")
      .classList.add("etapas-progresso-mobile-show");
    document
      .getElementById("globaletapaprox4")
      .classList.add("div-proximo-etapa-mobile-show");
  },
};
</script>
<style lang="scss">
@media screen and (max-width: 480px) {
  .full-frame {
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    border: none;
    z-index: 5;
  }
}
</style>